import { createContext, useState } from "react";
import { scrollToBottom } from "../utils.js";
import { addConversation } from "../components/navigation/2-1_ConversationCards.jsx";

const UserContext = createContext();

export function UserProvider({children})  {
    const [userContext, setUserContext] = useState({
        showAllDocs: false
    });

    const goHome = () => {
        const tempUserContext = {...userContext};
        delete tempUserContext.document;
        delete tempUserContext.conversationOverview;
        delete tempUserContext.conversation;
        setUserContext(tempUserContext);
    }

    const setAccount = (instance, account) => {
        console.log({account});
        const tempUserContext = {...userContext};
        tempUserContext.msalInstance = instance;
        tempUserContext.account = account;
        setUserContext(tempUserContext);
    }

    const setDocument = (document, doAddConversation) => {
        console.log(document);
        const tempUserContext = {...userContext};
        tempUserContext.document = document;
        delete tempUserContext.conversationOverview;
        delete tempUserContext.conversation;
        
        if (doAddConversation) { 
            addConversation(0, {userContext:tempUserContext, setUserContext, setAccount});
        } else {
            setUserContext(tempUserContext);
        }
    }

    const setConversationOverview = (conversationOverview) => {
        console.log(conversationOverview);
        const tempUserContext = {...userContext};

        tempUserContext.conversationOverview = conversationOverview;
        setUserContext(tempUserContext);
    }

    const addMessage = (message) => {
        const tempUserContext = {...userContext};
        const isArray = typeof message.type === 'undefined';

        if (tempUserContext.conversation && tempUserContext.conversation.messages) {
            if (isArray) {
                const existingMessages = tempUserContext.conversation.messages;
                tempUserContext.conversation.messages = existingMessages.concat(message);
            } else {
                tempUserContext.conversation.messages.push(message);
            }
        } else {
            if (isArray) {
                tempUserContext.conversation = {
                    messages: message
                }
            } else {
                tempUserContext.conversation = {
                    messages: [message]
                }
            }
        }
        
        setUserContext(tempUserContext);
        scrollToBottom();
    }

    const replaceMessage = (message) => {
        const tempUserContext = {...userContext};
        const isArray = typeof message.type === 'undefined';
        const numToReplace = isArray ? message.length : 1;
        const existingMessages = tempUserContext.conversation.messages.slice(0, -numToReplace);
        tempUserContext.conversation.messages = existingMessages.concat(message);
        setUserContext(tempUserContext);
        scrollToBottom();
    }

    return (
        <UserContext.Provider value={{userContext, setUserContext, setAccount, setDocument, setConversationOverview, addMessage, replaceMessage, goHome}}>
            {children}
        </UserContext.Provider>
    )
}

export default UserContext;